import { makeStyles } from "@material-ui/core";

export default makeStyles(theme => {
  const dark = theme.mode === "dark" || theme.palette.type === "dark";
  return {
    attention: {
      display: "inline-block", width: 9, height: 9, borderRadius: "50%", background: "#d9680b", marginRight: 8,
      animation: "$pulse 2s ease-in-out 3",
      "@media (prefers-reduced-motion: reduce)": { animation: "none" }
    },
    "@keyframes pulse": { "0%, 100%": { boxShadow: "0 0 0 0 rgba(217,104,11,.15)" }, "50%": { boxShadow: "0 0 0 5px rgba(217,104,11,.4)" } },
    root: {
      color: dark ? "#edf3f8" : "#172b3a",
      "& .MuiButton-root": { margin: 4, borderRadius: 6 },
      "& .MuiButton-textPrimary, & .MuiButton-textSecondary": {
        color: dark ? "#abd9ff" : "#174f79",
        border: `1px solid ${dark ? "#6996b8" : "#52758f"}`
      },
      "& .MuiButton-containedPrimary": {
        color: "#fff", backgroundColor: "#245f8e",
        "&:hover": { backgroundColor: "#194568" }
      },
      "& .MuiButton-outlined": {
        color: dark ? "#edf3f8" : "#172b3a",
        borderColor: dark ? "#91aabb" : "#52758f"
      },
      "& .MuiButton-root.Mui-disabled": { color: dark ? "#a5b2bd" : "#65727c", backgroundColor: dark ? "#293844" : "#e3e8ed", borderColor: "transparent" },
      "& input[type=date]": { colorScheme: dark ? "dark" : "light" }
    }
  };
});
